// extracted by mini-css-extract-plugin
export var borderRadius = "_br-4";
export var large = "_br-3";
export var logoContainer = "_br-0";
export var nameLogo = "_br-2";
export var small = "_br-1";